<div class="screen-element day-planner-screen">
  <div class="headline1">{{title|uppercase}}</div>
  <div class="headline2">{{subtitle}}</div>
  <div class="dashboard-center">

    @if (conflict) {
      <div class="value smaller">{{translator.tr("TIMEWINDOWS_EDITOR_INTERFACE")}}</div>
    }
    @if (!conflict) {
      <div class="value">{{getCurrentTime()| date:"HH:mm"}}</div>
    }
    <div class="unit"></div>
  </div>

  <div class="bar">
    <div class="bar-wrap" [ngStyle]="{left:left}">
      <div class="scale">

        @for (hour of hours; track hour) {
          <div class="hour">
            @if (hour % 3 == 0) {
              <span class="caption">{{hour}}</span>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,10)}"></div>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,20)}"></div>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,30)}"></div>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,40)}"></div>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,50)}"></div>
            }
            @if (hour < 24) {
              <div class="block" [ngStyle]="{background:getBackground(hour,55)}"></div>
            }
          </div>
        }

      </div>
    </div>
  </div>
  @if (stage == 'start_time') {
    <div class="rangeLimit rangeLimitMin"></div>
  }
  @if (stage == 'end_time') {
    <div class="rangeLimit rangeLimitMax"></div>
  }
</div>
